/*
 * Copyright (c) 2018. Rezo Zero
 *
 * This file is part of Supreme NTM.
 *
 * Supreme NTM can not be copied and/or distributed without
 * the express permission of Rezo Zero.
 *
 * @file ConcertsBlock.js
 * @author Ambroise Maupate <ambroise@rezo-zero.com>
 * @copyright Rezo Zero 2018
 */

import {AbstractBlock} from 'starting-blocks'
import * as log from 'loglevel'
import $ from 'jquery'

export default class ConcertsBlock extends AbstractBlock {
    init () {
        super.init()
        log.debug('\t🎤 Concerts listing')
        this.endpoint = this.$cont.attr('data-end-point')

        /**
         * @type {jQuery}
         */
        this.$body = $(document.body)

        if (!window.fetch) {
            throw new Error('window.fetch is not supported by your browser.')
        }

        if (this.endpoint && this.endpoint !== '') {
            this.fetchApi(this.endpoint).then((data) => {
                this.render(JSON.parse(data))
            })
        }
    }

    fetchApi (url) {
        return new Promise((resolve, reject) => {
            window.fetch(url, {
                method: 'GET',
                cache: 'default',
                credentials: 'same-origin'
            }).then(res => {
                if (res.status >= 200 && res.status < 300) {
                    return resolve(res.text())
                }
                const err = new Error(res.statusText || res.status)
                return reject(err)
            }).catch(err => {
                reject(err)
            })
        })
    }

    render (contents) {
        this.$body.addClass('content-loaded')

        for (const venue of contents) {
            const date = new Date(venue.datetime)
            const monthOptions = { month: 'long', day: 'numeric' }
            const yearOptions = { year: 'numeric' }
            const template = `
<div itemscope itemtype="http://schema.org/MusicEvent" class="concert d-flex" id="concert-${venue.id}">
    <meta itemprop="name" content="${venue.venue.name}" />
    <div class="column column--xs">
        <time itemprop="startDate"
              class="concert__date date" 
              datetime="${venue.datetime}">${date.toLocaleDateString('fr', monthOptions)}<br /><span class="year">${date.toLocaleDateString('fr', yearOptions)}</span></time>
    </div>
    <div class="column column--0-7 d-flex xs-inline">
        <div itemprop="location" itemscope itemtype="http://schema.org/MusicVenue" class="concert__venue">
            <p itemprop="name" class="concert__venue__title">${venue.venue.name}</p>
            <p itemprop="address" class="concert__venue__location">${venue.venue.city}, ${venue.venue.country}</p>
        </div>
    </div>
    <div itemprop="offers" itemscope itemtype="http://schema.org/Offer" class="concert__venue__btn">
        <a itemprop="url" target="_blank" href="${venue.url}" class="concert__link btn btn-default btn-hover-fill">Billet & RSVP</a>    
    </div>
</div>`

            this.$cont.append(template)
        }
    }

    onLoad () {
        super.onLoad()
    }

    onResize () {
        super.onResize()
    }

    onPageReady () {
        super.onPageReady()
    }

    destroyEvents () {
        super.destroyEvents()
    }

    destroy () {
        super.destroy()
        this.$body.removeClass('content-loaded')
    }

    initEvents () {
        super.initEvents()
    }
}



// WEBPACK FOOTER //
// ./webpack/js/blocks/ConcertsBlock.js